import { CenteredBlock, Icon } from '@/shared'
import { EIcons } from '@App/types/iconType'

import style from './FaqListEmpty.module.scss'

export const FaqListEmpty = () => (
    <CenteredBlock className={style.container}>
        <div>
            <span>Список Пуст</span>
        </div>
        <Icon iconName={EIcons.LOAD} color='rgba(173, 173, 173, 1)' width='100' height='100' />
    </CenteredBlock>
)
